"use client";

import { useSyncExternalStore } from "react";

/**
 * Sommes-nous dans l'application iOS Synoplix ?
 *
 * Le marqueur est posé par le script que l'application injecte au chargement
 * (dépôt `LeoWors/synoplix-ios`, `Synoplix/ScriptPont.swift`). Il n'existe
 * dans aucun navigateur.
 *
 * ── À QUOI ÇA SERT, ET POURQUOI C'EST OBLIGATOIRE ─────────────────────────
 * Règle App Store 3.1.1 : un abonnement consommé dans l'application doit passer
 * par l'achat intégré d'Apple. Proposer un paiement Stripe depuis l'app est un
 * motif de refus. On masque donc les parcours d'ACHAT dans l'app — l'offre en
 * cours et la consommation restent affichées, c'est l'information qui compte
 * pour quelqu'un en déplacement.
 *
 * ⚠ Ce drapeau n'accorde et ne retire AUCUN droit : il ne change que ce qui est
 * proposé à l'écran. Toute décision de licence reste côté serveur.
 *
 * `useSyncExternalStore` plutôt qu'un `useState` + `useEffect` : la valeur est
 * extérieure à React et ne change jamais après le chargement. L'instantané
 * serveur rend `false`, ce qui évite toute divergence d'hydratation — et on
 * n'écrit pas d'état dans un effet, ce qui provoquerait des rendus en cascade.
 */
const sAbonner = () => () => {};
const lireClient = () =>
  (globalThis as unknown as { __SYNOPLIX_IOS__?: boolean }).__SYNOPLIX_IOS__ === true;
const lireServeur = () => false;

export function useEstDansAppIOS(): boolean {
  return useSyncExternalStore(sAbonner, lireClient, lireServeur);
}
